export default __webpack_public_path__ + "static/media/img7.2a0c0d09.jpg";